module.exports = __webpack_public_path__ + "Breymont-Bold.26155738de68a0d14f0b.woff";


//////////////////
// WEBPACK FOOTER
// D:/TMB/TMB/MYTMB.UI/src/assets/scss/fonts/Breymont-Bold.woff
// module id = ../../../../../src/assets/scss/fonts/Breymont-Bold.woff
// module chunks = styles